import { render, staticRenderFns } from "./fileCategory.vue?vue&type=template&id=ea95e6b4&scoped=true&"
import script from "./fileCategory.vue?vue&type=script&lang=js&"
export * from "./fileCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea95e6b4",
  null
  
)

export default component.exports